import {
  deleteAdminV1OrgCustomizationsId,
  getAdminV1OrgAttributes,
  getAdminV1OrgCustomizations,
  getAdminV1OrgProductTypes,
  getAdminV1OrgProductTypesId,
  patchAdminV1OrgCustomizationsId,
  postAdminV1OrgAttributes,
  postAdminV1OrgAttributesIdValues,
  postAdminV1OrgCustomizations,
  type Attribute,
  type AttributeValue,
  type CreateAttributeRequest,
  type CreateAttributeValueRequest,
  type CreateCustomizationRequest,
  type Customization,
  type ProductType,
  type UpdateCustomizationRequest,
} from '@nucleus-commerce/api-client/admin';

/** Bounded dictionaries: the backend returns whole `{ items }` lists, no cursor. */
export const dictionaryApi = {
  listAttributes: (): Promise<Attribute[]> => getAdminV1OrgAttributes().then((r) => r.items),
  createAttribute: (body: CreateAttributeRequest): Promise<Attribute> =>
    postAdminV1OrgAttributes(body),
  createAttributeValue: (
    attributeId: string,
    body: CreateAttributeValueRequest,
  ): Promise<AttributeValue> => postAdminV1OrgAttributesIdValues({ id: attributeId }, body),
  listCustomizations: (): Promise<Customization[]> =>
    getAdminV1OrgCustomizations().then((r) => r.items),
  listProductTypes: (): Promise<ProductType[]> => getAdminV1OrgProductTypes().then((r) => r.items),
  getProductType: (id: string): Promise<ProductType> => getAdminV1OrgProductTypesId({ id }),
  createCustomization: (body: CreateCustomizationRequest): Promise<Customization> =>
    postAdminV1OrgCustomizations(body),
  updateCustomization: (id: string, body: UpdateCustomizationRequest): Promise<Customization> =>
    patchAdminV1OrgCustomizationsId({ id }, body),
  removeCustomization: (id: string): Promise<void> => deleteAdminV1OrgCustomizationsId({ id }),
};
